import cn from 'classnames';
import { WarningIcon } from '@phosphor-icons/react/dist/ssr';
import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, Text } from '@/shared/ui/core';
import styles from './report-success-popup.module.scss';


type ComponentProps = {
    open: boolean;
    onClose: () => void;
};


export function ReportSuccessPopup ({ open, onClose }: ComponentProps) {
    return (
        <Dialog
            open={ open }
            onOpenChange={ onClose }
        >
            <DialogContent className={ cn(styles.root, styles.content_wrapper) }>
                <DialogHeader className={ styles.header }>
                    <WarningIcon size={ 32 }/>

                    <div>
                        <DialogTitle>
                            <Text
                                weight="semibold"
                                lineHeight={ 1 }
                                className={ styles.dialog_title }
                            >
                                Report
                            </Text>
                        </DialogTitle>

                        <DialogDescription>
                            <Text
                                as="span"
                                tone="secondary"
                                size="lg"
                                lineHeight={ 1.2 }
                            >
                                Report submitted successfully
                            </Text>
                        </DialogDescription>
                    </div>
                </DialogHeader>

                <div className={ styles.content }>
                    <Text
                        weight="semibold"
                        lineHeight={ 1 }
                        className={ styles.thank }
                    >
                        Thank you!
                    </Text>

                    <Text
                        tone="secondary"
                        size="lg"
                        lineHeight={ 1.2 }
                        className={ styles.text }
                    >
                        Your report has been sent!
                        <br/>
                        <br/>
                        Our specialists will review it and get back to you within 24 hours using the contact information
                        you provided.
                    </Text>

                    <Button
                        onClick={ onClose }
                        className={ styles.button }
                    >
                        Close
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
